import React from "react";
import { Controller, useForm } from "react-hook-form";

const WorkAddress = () => {
    const {
        register,
        handleSubmit,
        watch,
        control,
        formState: { errors },
    } = useForm();
    const onSubmitWork = (data) => console.log(data);

    return(
        <div>
  <form className="profile-address-container" onSubmit={handleSubmit(onSubmitWork)}>
                                            <div className="t4 font-semibold">
                                                work
                                            </div>
                                            <Controller
                                                name="workaddress1"
                                                control={control}
                                                defaultValue=""
                                                render={({ field }) => (
                                                    <div className="delivery-input-container" >
                                                        <input type="address" placeholder="address line 1" {...field} />
                                                    </div>
                                                )}
                                            />
                                            <Controller
                                                name="workaddress2"
                                                control={control}
                                                defaultValue=""
                                                render={({ field }) => (
                                                    <div className="delivery-input-container" >
                                                        <input type="address" placeholder="address line 2" {...field} />
                                                    </div>
                                                )}
                                            />
                                            <div className="horizontalgroupaddress">
                                                <Controller
                                                    name="worktown"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <div className="delivery-input-container" >
                                                            <input type="town" placeholder="town/city" {...field} />
                                                        </div>
                                                    )}
                                                />
                                                <Controller
                                                    name="workpincode"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <div className="delivery-input-container" >
                                                            <input type="text" placeholder="pin code" {...field} />
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                            <Controller
                                                name="workstate"
                                                control={control}
                                                defaultValue=""
                                                render={({ field }) => (
                                                    <div className="delivery-input-container" >
                                                        <input type="state" placeholder="state" {...field} />
                                                    </div>
                                                )}
                                            />
                                            <button className="address-update-btn font-semibold t5" type="submit">
                                                Update
                                            </button>
                                        </form>   
        </div>
    )
}

export default WorkAddress;